export default "__VITE_ASSET__w$esb4Is__"